export enum CaseContactInformationPurposeType {
    UNKNOWN = 0,
    MAIN = 1,
    MARKETING = 2,
    SALES = 3,
    CUSTOMERSERVICE = 4,
    HOME = 5,
    WORK = 6,
    SEASONAL = 7,
    OTHER = 8,
}
